  import React, { useState, useEffect, useCallback } from 'react';
  import { getData, addData, updateData, deleteData } from '../../services/sliderServices';
  import { Button, Modal, Form } from 'react-bootstrap';
  import DataTable from 'react-data-table-component';
  import Header from '../../components/Layout/Header';
  import Footer from '../../components/Layout/Footer';
  import Sidebar from '../../components/Layout/Sidebar';
  import './homeslider.css';
  import {validateFile } from '../../utils/validators';
  import Spinner from '../../components/Spinner';
  import { toast } from 'react-toastify';

  const Homeslider = () => {
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({}); 
    const [data, setData] = useState([]);
    const [editingId, setEditingId] = useState(null)
    const [formData, setFormData] = useState({
      id: null,
      b_order: '',
      uploadedfile: null,
      alt_name: '',
    });
    const [modalType, setModalType] = useState(''); // 'add' or 'edit'
    const [showModal, setShowModal] = useState(false);
    const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
    const [selectedData, setselectedData] = useState(null);
    const [isSubmitting, setIsSubmitting] = useState(false);


    // Fetch data from API
    const fetchData = useCallback(async () => {
      setLoading(true);
      try{
      const response = await getData();
      setData(response);
      }
      catch(error){
        console.error('Failed to fetch data:', error);
      }
      finally {
        setTimeout(() => {
          setLoading(false);
        }, 500);
      }
    }, []);

    useEffect(() => {
      fetchData();
    }, [fetchData]);

    const validateForm = () => {
    const newErrors = {};
    if (!formData.uploadedfile ) {
      if (!errors.uploadedfile) newErrors.uploadedfile = "Slider is required";
    }
    if (!formData.b_order) newErrors.b_order = "Order  is required";  
    if (!formData.alt_name) newErrors.alt_name = "Alt name is required";

    setErrors((prev) => ({ ...prev, ...newErrors }));
    return Object.keys({ ...errors, ...newErrors }).every((key) => !errors[key] && !newErrors[key]);
  };

    const handleChange = async(e) => {
      try{
      const { name, value, files } = e.target;
      const file = files?.[0];
        // Create a copy of the current form data
        let updatedData = { ...formData };
        let updatedErrors = { ...errors };
        if (file) {
          const fileType = file.type.includes("image") ? "img" : "pdf";        
          const isValid = await validateFile(file, setErrors,name,fileType);
          if (isValid) {
            updatedData[name] = file;
            updatedErrors[name] = '';
          }
          else{
            return ; // Don't update if invalid
          }
        }
        else{
          updatedData[name] = value;
          if (value) {
        updatedErrors[name] = ''; // Clear error if corrected
        }
        }
        setFormData(updatedData);
        setErrors(updatedErrors);
        const isValid = /^[0-9]*$/.test(value);
        if (name === "b_order") {
          if (value.trim() === '') {
          updatedErrors[name] = "Order is required";
        }  
        else if (!isValid) {
            updatedErrors[name] = "Only numbers are allowed";
            setErrors(updatedErrors);
          }
        else if(Number(value) === 0){
            updatedErrors[name] = "Order value must greater than zero";
          }
        else {
            const isDuplicate = data.some((item) => {
            if (item.id === editingId) return false; // skip comparing with self
            return  item?.order_num === Number(value);
            });
            if (isDuplicate) {
            updatedErrors[name] = "Order is already exists";
            } else {
              updatedErrors[name] = ''; // Clear error if unique
            }
        }   
          setErrors(updatedErrors);
        }
      }
      catch(error){
        console.error("Error in handleChange:", error);
      }
    };
    
    const handleSubmit = async (e) => {
      e.preventDefault();
      if (isSubmitting) return; // prevent multiple clicks
      if (!validateForm()) {
        return
      }
      setIsSubmitting(true); // disable button

      try{
      const form = new FormData();
      form.append('id', formData.id);
      form.append('b_order', formData.b_order);
      form.append('uploadedfile', formData.uploadedfile);
      form.append('alt_name', formData.alt_name);

      if (modalType === 'add') {
        const result = await addData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
          toast.success("Saved Successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
          position: 'top-right',
          });
             console.log("Failed to process the request.");
        }
      } else if (modalType === 'edit') {
        const result = await updateData(form);
        if (result.status === 200) {
          fetchData();
          setShowModal(false);
           toast.success("Updated Successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          toast.error(result.message ||"Failed to update data. Please try again.", {
                                    position: 'top-right',
                                  });
             console.log("Failed to process the request.");
        }
      }
    }
    catch (error) { 
        console.error("Error:", error.message);
        }
        finally {
        setIsSubmitting(false); // re-enable button
      }
    };

    const handleDelete = async () => {
       try{
      if (selectedData) {
        const result = await deleteData(selectedData.id);
        if (result.status === 200) {
          fetchData();
          setShowDeleteConfirmModal(false);
          toast.success("Deleted successfully!", {
              position: 'top-right',
              autoClose: 3000,
            });
        } else {
          toast.error("Failed to delete getData:", {
              position: 'top-right',
              autoClose: 3000,
            });
        }
      }
    }
      catch(error){
          console.error("Error in handleDelete:", error);
        }
        finally {
          setIsSubmitting(false); // re-enable button
        }
    };

    const openModal = (type, data = { id: null, b_order: '', uploadedfile: null, alt_name: '' }) => {
      setModalType(type);
      setEditingId(data?.id); 
      setFormData(data);
      setShowModal(true);
    };

    const closeModal = () => {
      setShowModal(false);
    };

    const openDeleteConfirmModal = (data) => {
      setselectedData(data);
      setShowDeleteConfirmModal(true);
    };

    const closeDeleteConfirmModal = () => {
      setShowDeleteConfirmModal(false);
      setselectedData(null);
    };
    const sortedData = [...data].sort((a, b) => Number(a.order_num) - Number(b.order_num));
    const columns = [
      {
        name: 'Order',
        selector: (row) => row?.order_num,
        sortable: true,
      },
      {
        name: 'Slider',
        cell: (row) => {return(
          <div>
              <img
                src={row?.slider_img}
                alt={row?.alt_name || 'SliderImage'}
                style={{ width: '60px', height: '40px', objectFit: 'cover' }}
                crossOrigin="anonymous"
              />
            </div>
        ) 
      },
        sortable: false,
      },
        {
      name: 'Alt Name',
      selector: (row) => row?.slider_alt_txt,
      cell: (row) => (
            <span title={row?.slider_alt_txt}>
              {row?.slider_alt_txt}
            </span>
          ),
      sortable: true,
      },
      {
        name: 'Actions',
        cell: (row) => (
          <div>
            <Button
              className="me-2"
              variant="warning"
              size="sm"
              onClick={() => openModal('edit', {
                id: row?.id,
                b_order: row?.order_num,
                uploadedfile: row?.slider_img,
                alt_name: row?.slider_alt_txt,
              })}
            >
              Edit
            </Button>
            <Button
              variant="danger"
              size="sm"
              onClick={() => openDeleteConfirmModal(row)}
            >
              Delete
            </Button>
          </div>
        ),
      },
    ];

    return (
      <div className="d-flex">
        <Sidebar />
        <div className="main-content w-100">
          <Header />
          {loading ? (
          <div className="d-flex justify-content-center align-items-center w-100" style={{ minHeight: "300px" }}>
          <Spinner />
        </div>
      ) :(
        <div>
          <div className="container-fluid p-4">
            <div className="row">
            <div className="col-8">
            <p className="fs-4">Event Pages / Conference <b>/ Sliders Banner</b></p>
            </div>
            <div className="col-4 text-end">
              <button className="btn btn-primary mb-3" onClick={() => openModal('add')}>Add</button>
              </div>
            </div>
           
            {/* DataTable for data */}
            {columns && sortedData && (
            <DataTable
              columns={columns}
              data={sortedData}
              pagination
              highlightOnHover
              responsive
              striped
              paginationPerPage={10}
              paginationComponentOptions={{
              noRowsPerPage: true, // Hide rows per page option
              }}
            />
            )}

            {/* Modal for Add/Edit data */}
            <Modal show={showModal} onHide={closeModal} backdrop="static">
              <Modal.Header closeButton>
                <Modal.Title className='form-label-custom fs-3'>{modalType === 'add' ? 'Add' : 'Edit'}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Form onSubmit={handleSubmit}>
                  <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Order <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                      type="text"
                      name="b_order"
                      value={formData.b_order}
                      onChange={handleChange}
                      isInvalid={!!errors.b_order}
                    />
                 <Form.Control.Feedback type="invalid">{errors.b_order}</Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group className="mb-3" >
                    <Form.Label className='form-label-custom'>
                      Slider<small className='text-danger'> * </small> <small className="text-primary form-label-note">(Dimension:1200x630 | Size:10kb-100kb)</small>
                    </Form.Label>
                    <Form.Control
                      type="file"
                      name="uploadedfile"
                      onChange={handleChange}
                      isInvalid={!!errors.uploadedfile}
                    />
                 <Form.Control.Feedback type="invalid">{errors.uploadedfile}</Form.Control.Feedback>

                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className='form-label-custom'>Alt Name <small className='text-danger'> * </small></Form.Label>
                    <Form.Control
                      type="text"
                      name="alt_name"
                      value={formData.alt_name}
                      onChange={handleChange}
                      isInvalid={!!errors.alt_name}
                    />
                    <Form.Control.Feedback type="invalid">{errors.alt_name}</Form.Control.Feedback>

                  </Form.Group>

                  <Modal.Footer className='border-0'>
                    <Button variant="secondary" onClick={closeModal}>
                      Cancel
                    </Button>
                    <Button variant="primary"  disabled={isSubmitting}  type="submit">
                       {isSubmitting ? 'Saving...' : (modalType === 'add' ? 'Add' : 'Save')}
                    </Button>
                  </Modal.Footer>
                </Form>
              </Modal.Body>
            </Modal>

            {/* Delete Confirmation Modal */}
            <Modal show={showDeleteConfirmModal} onHide={closeDeleteConfirmModal}>
              <Modal.Header closeButton>
                <Modal.Title>Delete</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>Are you sure you want to delete this row?</p>
              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary" onClick={closeDeleteConfirmModal}>
                  Cancel
                </Button>
                <Button variant="danger" onClick={handleDelete}>
                  Yes, Delete
                </Button>
              </Modal.Footer>
            </Modal>
          </div>
          <Footer />
           </div>
        )}
        </div>
      </div>
    );
  };

  export default Homeslider;